import React from 'react';
import PropTypes from 'prop-types';

import ConfirmDialog from '../../../SavedLists/ConfirmDialog';

// The ticket's data-testid contract pins this exact literal (no `modal.` namespace), matching the
// sibling RemovePlayerConfirmModal / SaveToListModal — the web verifier's Playwright selectors
// depend on it. Intentional deviation from CLAUDE.md rule 4; don't "fix" it to the general convention.
// Renders the shared ConfirmDialog; keeps the default `.confirm-btn` suffix (CLAUDE.md rule 8).
const TESTID_PREFIX = 'delete-list-confirm-modal';
const MODAL_TITLE = 'Delete List';
const CANCEL_LABEL = 'Cancel';
const DELETE_LABEL = 'Delete';
// Figma 383-11671 copy is generic — no list-name interpolation.
const DELETE_MESSAGE = 'Are you sure you want to delete this list from your Saved Player Lists? This cannot be undone.';

const DeleteListConfirmModal = ({ isDeleting, onConfirm, onCancel }) => (
    <ConfirmDialog
        title={MODAL_TITLE}
        message={DELETE_MESSAGE}
        confirmLabel={DELETE_LABEL}
        cancelLabel={CANCEL_LABEL}
        destructive
        mobileActionSheet
        isBusy={isDeleting}
        onConfirm={onConfirm}
        onCancel={onCancel}
        data-testid={TESTID_PREFIX}
    />
);

DeleteListConfirmModal.propTypes = {
    isDeleting: PropTypes.bool,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

DeleteListConfirmModal.defaultProps = {
    isDeleting: false,
};

export default DeleteListConfirmModal;
